import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { Box, Button, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Slide from "@mui/material/Slide";

const pldWhatsAppUrl =
   "https://api.whatsapp.com/send?phone=5216622885088&text=Hola%2C%20me%20interesa%20el%20M%C3%B3dulo%20PLD.";

export const PldLaunchModal = ({ open, handleClose }) => {
   const cardRef = useRef(null);
   const [panelRect, setPanelRect] = useState(null);

   const handleNotify = () => {
      window.open(pldWhatsAppUrl, "_blank", "noopener,noreferrer");
      handleClose();
   };

   useEffect(() => {
      if (!open) return undefined;
      const onKeyDown = (event) => {
         if (event.key === "Escape") handleClose();
      };
      window.addEventListener("keydown", onKeyDown);
      return () => window.removeEventListener("keydown", onKeyDown);
   }, [open, handleClose]);

   useEffect(() => {
      let frame = 0;
      let running = true;
      let observer;
      const stopAt = performance.now() + 700;

      const measure = () => {
         const node = cardRef.current;
         if (!node) {
            setPanelRect((current) => (current == null ? current : null));
            return;
         }
         if (!observer) {
            observer = new ResizeObserver(() => measure());
            observer.observe(node);
         }
         const rect = node.getBoundingClientRect();
         const next = {
            top: rect.top,
            left: rect.left,
            width: rect.width,
            height: rect.height,
         };
         setPanelRect((current) => {
            if (
               current &&
               current.top === next.top &&
               current.left === next.left &&
               current.width === next.width &&
               current.height === next.height
            ) {
               return current;
            }
            return next;
         });
      };

      const tick = () => {
         if (!running) return;
         measure();
         if (performance.now() < stopAt) frame = requestAnimationFrame(tick);
      };

      frame = requestAnimationFrame(tick);
      window.addEventListener("resize", measure);
      return () => {
         running = false;
         cancelAnimationFrame(frame);
         observer?.disconnect();
         window.removeEventListener("resize", measure);
      };
   }, [open]);

   const panel = (
      <>
         {panelRect && (
            <Box
               aria-hidden
               sx={{
                  position: "fixed",
                  zIndex: 1298,
                  top: panelRect.top,
                  left: panelRect.left,
                  width: panelRect.width,
                  height: panelRect.height,
                  borderRadius: "25px",
                  pointerEvents: "none",
                  boxShadow: "0px 4px 9.8px 0px rgba(0, 0, 0, 0.25)",
               }}
            />
         )}
         {panelRect && (
            <Box
               aria-hidden
               sx={{
                  position: "fixed",
                  zIndex: 1299,
                  top: panelRect.top,
                  left: panelRect.left,
                  width: panelRect.width,
                  height: panelRect.height,
                  borderRadius: "25px",
                  pointerEvents: "none",
                  bgcolor: { xs: "rgba(122, 204, 194, 0.55)", md: "#7ACCC2" },
                  mixBlendMode: { xs: "normal", md: "screen" },
                  backdropFilter: { xs: "blur(12px)", md: "none" },
                  WebkitBackdropFilter: { xs: "blur(12px)", md: "none" },
               }}
            />
         )}
         <Box
            sx={{
               position: { xs: "fixed", md: "static" },
               inset: { xs: 0, md: "auto" },
               zIndex: 1300,
               display: { xs: "flex", md: "contents" },
               alignItems: "center",
               justifyContent: "center",
               pointerEvents: "none",
               px: { xs: 2, md: 0 },
            }}
         >
            <Slide direction="left" in={open} mountOnEnter unmountOnExit>
               <Box
                  ref={cardRef}
                  role="dialog"
                  aria-labelledby="pld-launch-title"
                  sx={{
                     pointerEvents: "auto",
                     position: { xs: "relative", md: "fixed" },
                     zIndex: 1300,
                     right: { md: 48 },
                     bottom: { md: 72 },
                     width: { xs: "100%", sm: 539 },
                     maxWidth: 539,
                     height: { xs: "auto", sm: 450 },
                     borderRadius: "25px",
                     bgcolor: "transparent",
                     px: { xs: 2.5, sm: 3.5 },
                     py: { xs: 2.5, sm: 3 },
                     outline: "none",
                  }}
               >
                  <IconButton
                     onClick={handleClose}
                     aria-label="Cerrar"
                     sx={{ position: "absolute", top: 10, right: 10, color: "#2D4357" }}
                  >
                     <CloseIcon />
                  </IconButton>

                  <Typography
                     id="pld-launch-title"
                     sx={{ color: "#2D4357", lineHeight: 1.15, textAlign: "center", pr: { sm: "120px" } }}
                  >
                     <Box component="span" sx={{ display: "block", fontFamily: "Regular", fontSize: "32px" }}>
                        Próximo lanzamiento
                     </Box>
                     <Box component="span" sx={{ display: "block", fontFamily: "Bold", fontSize: "32px" }}>
                        Módulo PLD
                     </Box>
                  </Typography>

                  <Box
                     sx={{
                        position: "relative",
                        display: "flex",
                        justifyContent: { xs: "flex-start", sm: "center" },
                        alignItems: "center",
                        gap: { xs: 1.5, sm: 0 },
                        mt: 1,
                        pr: { xs: 0, sm: "120px" },
                        minHeight: { xs: "auto", sm: 194 },
                     }}
                  >
                     <Box
                        sx={{
                           width: { xs: 120, sm: 194 },
                           height: { xs: 120, sm: 194 },
                           flexShrink: 0,
                           backgroundImage:
                              "url(https://images-lecosy.s3.us-west-2.amazonaws.com/assets/website/iconos/Icono+metal+mockup-PLD+1.svg)",
                           backgroundRepeat: "no-repeat",
                           backgroundPosition: "center",
                           backgroundSize: "contain",
                        }}
                     />
                     <Typography
                        sx={{
                           position: { xs: "relative", sm: "absolute" },
                           right: { sm: 0 },
                           flex: { xs: 1, sm: "none" },
                           fontFamily: "Bold",
                           fontSize: { xs: "14px", sm: "16px" },
                           color: "#2D4357",
                           textAlign: "right",
                           lineHeight: 1.35,
                           maxWidth: { xs: "none", sm: 170 },
                        }}
                     >
                        Cumpla con el enfoque basado en riesgos a través de nuestro sistema Lecosy.
                     </Typography>
                  </Box>

                  <Typography sx={{ textAlign: "center", lineHeight: 1.35, mt: 1, pr: { sm: "120px" } }}>
                     <Box component="span" sx={{ display: "block", fontFamily: "Bold", fontSize: "16px", color: "#2D4357" }}>
                        El plazo se acerca.
                     </Box>
                     <Box
                        component="span"
                        sx={{ display: "block", fontFamily: "ExtraBold", fontSize: "16px", color: "#4778A5" }}
                     >
                        ¿Su organización está lista?
                     </Box>
                  </Typography>

                  <Box sx={{ display: "flex", justifyContent: "center", mt: 2.5, pr: { sm: "120px" } }}>
                     <Button
                        onClick={handleNotify}
                        sx={{
                           bgcolor: "#162C44",
                           color: "#FFFFFF",
                           borderRadius: "10px",
                           textTransform: "none",
                           px: 3,
                           py: 1,
                           "&:hover": { bgcolor: "#0f1e30" },
                        }}
                     >
                        <Typography sx={{ fontFamily: "Bold", fontSize: "18px", color: "#FFFFFF" }}>
                           Notificarme 🔔
                        </Typography>
                     </Button>
                  </Box>
               </Box>
            </Slide>
         </Box>
      </>
   );

   if (typeof document === "undefined") return null;
   return createPortal(panel, document.body);
};
